<template>
    <div v-if="locales.length > 0">
        <span v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="mr-3">
            <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
        </span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'app-locales',

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/template/Locales.vue